import '../pages.css';
import { Link } from 'react-router-dom';

const ZirconiaAbutment = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/implants" className="back-link">← Back to Implants/Hybrid</Link>
                    <h1>Zirconia Abutment</h1>
                    <p className="product-tagline">Optimal esthetic outcomes with metal-free design</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Zirconia abutments from <strong>AbELab</strong> are crafted with meticulous attention to detail to achieve optimal
                            esthetic outcomes. Their metal-free, biocompatible composition makes them particularly suitable for patients with
                            high esthetic demands or thin gingival biotypes. These abutments provide natural gingival color support while
                            maintaining strength and precision at the implant interface.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ZirconiaAbutment;
